(function() {
  const WISHLIST_KEY = 'tatva_krti_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]');
    } catch (e) {
      return [];
    }
  }

  function setWishlist(wishlist) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    updateHeaderWishlistIcon();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { wishlist } }));
  }

  function toggleWishlist(productId) {
    let wishlist = getWishlist();
    const index = wishlist.indexOf(productId);
    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(productId);
    }
    setWishlist(wishlist);
    return index === -1;
  }

  function updateHeaderWishlistIcon() {
    const wishlist = getWishlist();
    const count = wishlist.length;

    // Update the heart icon active state
    const heartIcons = document.querySelectorAll('.wishlist-icon');
    heartIcons.forEach(icon => {
      if (count > 0) {
        icon.classList.add('is-active');
      } else {
        icon.classList.remove('is-active');
      }
    });

    // Update count badge
    const badges = document.querySelectorAll('.wishlist-bubble');
    badges.forEach(badge => {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = '';
      } else {
        badge.style.display = 'none';
        badge.textContent = '';
      }
    });
  }

  function initWishlistButtons() {
    const wishlist = getWishlist();
    document.querySelectorAll('.product-card-wishlist-btn').forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      if (wishlist.includes(productId)) {
        btn.classList.add('is-active');
        btn.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        btn.classList.remove('is-active');
        btn.setAttribute('aria-label', 'Add to wishlist');
      }
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('.product-card-wishlist-btn');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      const productId = btn.getAttribute('data-product-id');
      const isAdded = toggleWishlist(productId);
      
      btn.classList.toggle('is-active', isAdded);
      btn.setAttribute('aria-label', isAdded ? 'Remove from wishlist' : 'Add to wishlist');

      if (!isAdded && document.getElementById('WishlistGridContainer')) {
        const gridItem = btn.closest('.product-grid__item');
        if (gridItem) {
          gridItem.style.opacity = '0';
          gridItem.style.transform = 'scale(0.9)';
          gridItem.style.transition = 'all 0.3s ease';
          setTimeout(() => {
            gridItem.remove();
            const remaining = document.querySelectorAll('.product-card-wishlist-btn');
            if (remaining.length === 0) {
              const emptyMsg = document.getElementById('WishlistEmptyState');
              if (emptyMsg) emptyMsg.style.display = 'block';
              const grid = document.getElementById('WishlistGrid');
              if (grid) grid.style.display = 'none';
            }
          }, 300);
        }
      }
    }
  });

  function init() {
    updateHeaderWishlistIcon();
    initWishlistButtons();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('view-transitions:complete', init);
  
  window.TatvaKrtiWishlist = {
    get: getWishlist,
    set: setWishlist,
    toggle: toggleWishlist,
    updateHeader: updateHeaderWishlistIcon,
    init: init
  };
})();
